import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Link, navigate } from 'gatsby'
import cx from 'clsx'
// Redux
import { loadFilter, setModal, setSort } from '~lib/saga/filter/actions'
// Styles
import useStyles from './CategoryNavItem.style'

const filterSelector = (state) => state.filter

const CategoryNavItem = ({ id: categoryId, name, path }) => {
  const dispatch = useDispatch()
  const {
    data: { id: filterId, size: filterSize, year: filterYear },
  } = useSelector(filterSelector)

  const handleFilterLoad = (event, id) => {
    event.preventDefault()
    dispatch(loadFilter(id))
    dispatch(setModal(false))
    // @note[request] If we move between categories, force `rank`
    dispatch(setSort('rank'))

    navigate(`/${filterYear}/${id}`)
  }

  const classes = useStyles({ categoryId })

  const isSelected = 1 === filterSize && categoryId === filterId[0]

  return (
    <li
      className={cx(
        classes.categoryNavItem,
        isSelected && classes.categoryNavItemSelected
      )}
      data-selected={isSelected}
      id={categoryId}
    >
      <Link
        className={cx(
          classes.categoryNavLink,
          isSelected && classes.categoryNavLinkSelected
        )}
        onClick={(event) => handleFilterLoad(event, [categoryId])}
        to={path}
      >
        {name}
      </Link>
    </li>
  )
}

CategoryNavItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  path: PropTypes.string,
}

CategoryNavItem.defaultProps = {
  id: 0,
  name: '',
  path: '',
}

export default CategoryNavItem
